import dayjs from '@/services/date'
import { twentyFourHourTimeRegex } from '@/utils/regex.js'

export default function calcTimeDifference(
  startTime,
  endTime,
  units = 'minutes'
) {
  if (!startTime || !endTime) throw Error('startTime and endTime are required')
  if (typeof startTime !== 'string')
    throw Error('Invalid data type for startTime (Expected String)')
  if (typeof endTime !== 'string')
    throw Error('Invalid data type for endTime (Expected String)')
  if (typeof units !== 'string')
    throw Error('Invalid data type for units (Expected String)')

  if (
    !twentyFourHourTimeRegex.test(startTime) ||
    !twentyFourHourTimeRegex.test(endTime)
  )
    throw Error('Invalid time format (Expected HH:mm. e.g. 15:30)')
  try {
    const ft = dayjs(`2000-01-01 ${startTime}`)
    const tt = dayjs(`2000-01-01 ${endTime}`)
    return tt.diff(ft, units, true)
  } catch {
    console.error(
      `Unable to process startTime: ${startTime} endTime: ${endTime} units: ${units}`
    )
  }
}
